const STROKE = 'fill="none" stroke="currentColor" stroke-linejoin="round"';

export const TATOUE_MARK =
  '<g transform="rotate(40 12 12)">' +
  `<rect x="9" y="2" width="6" height="11" rx="2.2" ${STROKE} stroke-width="2"/>` +
  '<path d="M10.5 6h3M10.5 9h3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
  '<path d="M9.6 13h4.8l-1 4.4h-2.8z" fill="currentColor"/>' +
  '<path d="M12 17.4v3.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
  '<circle cx="12" cy="22.4" r="1.3" fill="currentColor"/></g>';

export const MOTIF_ICON =
  `<circle cx="12" cy="12" r="9.5" ${STROKE} stroke-width="1.8"/>` +
  [0, 60, 120, 180, 240, 300]
    .map(
      (turn) =>
        `<ellipse cx="12" cy="7.3" rx="1.7" ry="3" transform="rotate(${String(turn)} 12 12)" ${STROKE} stroke-width="1.3"/>`,
    )
    .join('') +
  '<circle cx="12" cy="12" r="1.6" fill="currentColor"/>';
